import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getAdvertisingUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.paidsearch.url');
  }

  return get(cfg, 'common.paidsearch.wl_url');
};

export default getAdvertisingUrl;
